import { render, staticRenderFns } from "./Conviction.vue?vue&type=template&id=37200f65&scoped=true&"
import script from "./Conviction.vue?vue&type=script&lang=js&"
export * from "./Conviction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37200f65",
  null
  
)

export default component.exports